import React from "react";
import { getMonthDiff } from "../../../../services/dateFormatter";

export const InterviewSidebarPregnancyItem = ({ pregnancy }) => {
    if (pregnancy == null) {
        return <></>;
    }

    return (
        <>
            {pregnancy.isPregnant && (
                <div className="row">
                    Pregnant, expecting {pregnancy.expectedChildren}{" "}
                    {pregnancy.expectedChildren > 1 ? "children" : "child"} in {getMonthDiff(pregnancy.expectedDueDate)}{" "}
                    {getMonthDiff(pregnancy.expectedDueDate) > 1 ? " months" : " month"}
                </div>
            )}
        </>
    );
};
